import React, { useState, useEffect } from "react";

import {
  Button,
  Chip,
  colors,
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";

import { uri } from "../../../../help/Api";
import TotalCard from "../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
  useStylesHed,
  useStylesSpDial,
  useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import { sto } from "../../../../Context/InshData";
import ItemsMovementTotalTable from "./ItemsMovementTotalTable";
import ItemsMovementTotalForm from "./ItemsMovementTotalForm";

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  itemW: {
    // display:'flex',
    width: "90%",
  },
  headerTitle: {
    backgroundColor: colors.green[50],
    textAlign: "center",
    fontSize: 20,
    width: "100%",
  },

  allWidth: {
    minWidth: 650,
  },
  checStyl: {
    marginTop: "17px",
    fontSize: "16px",
    padding: "-1px",
  },
  purchTotalCard: {
    backgroundColor: colors.blue[50],
    borderColor: colors.blue[300],
  },
}));

export default function ItemsMovementTotal(props) {
  const { AutoOptions } = props;
  const { t } = useTranslation(["forms", "translation"]);

  let idSafe=AutoOptions.Safes[0].id;
  let nameSafe=AutoOptions.Safes[0].name;

  let idBranch=AutoOptions.Branches[0].id;
  let nameBranch=AutoOptions.Branches[0].name;
  const [items, setItems] = useState(() => {
    return [{ id: -1, name: t("all"),i:-1,barcode:"-1" }, ...AutoOptions.items];
});

  const typeSearch = [
    { id: 1, name: t("show_zero_balances"),label:true },
    { id: 2, name: t("donot_show_zero_balances"),label:false },
];
const maxUnit = [
    { id: 0, name: t("default_unit"),label:true },
    { id: 1, name: t("large_unit_of_item"),label:false },
];
  const defaultValues = {
    dateFrom: moment(new Date()).format('YYYY-MM-DD'),
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    branch: {id: sto.User_typei==1?-1:idBranch, name:sto.User_typei==1?t("all"):nameBranch},  
    safe:{id:sto.User_typei==1?-1:idSafe, name: sto.User_typei==1?t("all"):nameSafe},
    curr: items[0],
    typeSearch:typeSearch[0],
    subUnit:{unitName:t("default_unit"),unit:1,perc:1},
    maxUnit:maxUnit[0],
    center:AutoOptions?.center[0],
  }
  let from_date=moment(new Date()).subtract().format("YYYY")+"-01-01";
  const [rptParams, setRptParams] = React.useState({...defaultValues,dateFrom:from_date});
  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();

  const [data, setData] = useState([]);
  const [subUnit, setSubUnit] = useState([]);

  const [fetching, setFetching] = useState(false);
  const viewHandle = async () => {

    setData([]);
    setFetching(true);
    await axios
      .get(
        uri +
        `RptSafes/ItemsTotalMovement?Fdate=${rptParams.dateFrom}
    &&Tdate=${rptParams.dateTo}
    &&branch=${rptParams.branch?.id}
    &&safe=${rptParams.safe?.id}
    &&curr_id=${rptParams.curr?.id}
    &&center=${rptParams.center?.id}
    &&Show_zero=${rptParams.typeSearch?.id}
    &&maxUnit=${rptParams.curr?.id==-1?rptParams.maxUnit.id:maxUnit[0].id}`
      )
      .then((res) => {
        setData(res.data);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        viewHandleOld();
      });
  };
  const viewHandleOld = async () => {

    setData([]);
    setFetching(true);
    await axios
      .get(
        uri +
        `RptSafes/ItemsTotalMovement?Fdate=${rptParams.dateFrom}
    &&Tdate=${rptParams.dateTo}
    &&branch=${rptParams.branch?.id}
    &&safe=${rptParams.safe?.id}
    &&curr_id=${rptParams.curr?.id}
    &&Show_zero=${rptParams.typeSearch?.id}
    &&maxUnit=${rptParams.curr?.id==-1?rptParams.maxUnit.id:maxUnit[0].id}`
      )
      .then((res) => {
        setData(res.data);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        // toast.err("يوجد خطأ في الجلب");
        setData([]);
      });
  };


  const his = useHistory();

  let excel_name= "ItemMovementReport" ;

  const excelHeaders = [
    {label: "رقم الصنف", key: "item_ID",},
    {label: "اسم الصنف", key: "currName",},
    {label: "التكلفة", key: "cost",},
    {label: "اول مدة", key: "initial",},
    {label: "المشتريات", key: "Buyment",},
    {label: "مرتجع الشراء", key: "ReBuyment",},
    {label: "البع", key: "Sales",},
    {label: "مرتجع البيع", key: "ReSales",},
    {label: "التوريد", key: "Twreed",},
    {label: "الصرف", key: "Sarf",},
    {label: "التحويل", key: "Tahweel",},
    {label: "الاستلام", key: "Estelam",},
    {label: "التسوية", key: "tsweya",},
    {label: "الرصيد", key: "Blc",},
    {label: "اجمالي التكلفة", key: "TotalCost",},


  ];

  const reloadGets = (rowData) => {
    const tb = {
      // wait: true,
      EmpUnits: true,
      parms: {
        icurr: rowData?.id,
      },
    };

    axios
      .post(uri + "GetD", tb)
      .then((res) => {
        setSubUnit(res.data?.unitsSub);
       // setRptParams({ ...rptParams, subUnit:res.data?.unitsSub[0]});

      })
      .catch((error) => {
      });
  };

  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeAutoData = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue });
  };

  const onChangeAutoDataCurr = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue});
    if(newValue.id==-1){
        setRptParams({ ...rptParams, maxUnit:maxUnit[0]});
    }
    reloadGets(newValue);

  };
  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Typography
          size="small"
          className={classes.headerTitle}
          color="primary"
        >
          { t("total_movement_of_items_report")} 
        </Typography>
      </Grid>
      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            paddingBottom: "0px",
            borderBottomColor:  colors.blue[300] ,
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
          }}
        >
          <ItemsMovementTotalForm
            {...{
              AutoOptions,
              rptParams,
              onChangeData,
              onChangeAutoData,
              typeSearch,
              items,
              subUnit,
              maxUnit,
              onChangeAutoDataCurr,
            }}
          />
          <Grid
            container
            justifyContent="center"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            spacing={1}
          >
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<ScannerIcon />}
                size="large"
                style={
                  ( inshst.purch.iconBtn,
                  { borderRadius: 0 })
                }
                className={[clasui.button]}
                onClick={() => viewHandle()}
              >
                {t("forms:view")}
              </Button>
            </Grid>
            <Grid item >
              {data && !fetching && data.itemsTotMovment && (
                <CSVLink
                  separator={";"}
                  filename={excel_name}
                  data={data.itemsTotMovment}
                  headers={excelHeaders}
                >
                  {" "}
                  <Button
                    disabled={fetching}
                    variant="contained"
                    startIcon={<TableChart />}
                    size="large"
                    color="primary"
                    style={{ borderRadius: 0 }}
                    className={[clasui.button]}
                  >
                    {t("excel_export")}{" "}
                  </Button>
                </CSVLink>
              )}
            </Grid>
            {/* <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<PrintIcon />}
                color="primary"
                size="large"
                className={[clasui.button, clasSp.clSec]}
                style={
                  ( inshst.purch.iconBtn ,
                  { borderRadius: 0 })
                }
                onClick={printHandle}
              >
                {t("forms:print")}
              </Button>
            </Grid> */}
            <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                className={[clasui.button, clasSp.clcan]}
                style={
                  ( inshst.purch.iconBtn,
                  { borderRadius: 0 })
                }
                onClick={() => his.goBack()}
              >
                {t("forms:exit")}
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container spacing={1} style={{ paddingTop: "10px" }}>
          <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: classes.purchTotalCard ,
                  title:t("count_row"),
                  value: data?.totals?.countRow,
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className:  classes.purchTotalCard ,
                  title:t("net_incoming"),
                  value:rptParams.curr.id==-1? data?.totals?.totWard .toFixed(2):(data?.totals?.totWard/rptParams.subUnit.perc) .toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className:  classes.purchTotalCard ,
                  title:t("net_exchange"),
                  value:rptParams.curr.id==-1? data?.totals?.totSarf .toFixed(2):(data?.totals?.totSarf/rptParams.subUnit.perc) .toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className:  classes.purchTotalCard ,
                  title:t("net_balance"),
                  value:rptParams.curr.id==-1?  data?.totals?.Blc.toFixed(2):(data?.totals?.Blc /rptParams.subUnit.perc).toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className:  classes.purchTotalCard ,
                  title:t("total_cost"),
                  value: data?.totals?.TotalCost.toFixed(2),
                }}
              />
            </Grid>
          </Grid>
        </Container>
        {/* <br /> */}
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
          }}
        >
          <Grid container justifyContent="center">
            <Grid item container justifyContent="center" xs={12}>
              <BeatLoader loading={fetching} color={colors.green[300]} />
              {!fetching && (
                <ItemsMovementTotalTable
                  {...{
                    data: data?.itemsTotMovment ? data.itemsTotMovment : [],
                    rptParams
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Container>
      </Typography>
    </div>
  );
}
